import React from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Box,
  Button,
  Card,
  Hidden,
  TablePagination,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { MenuButton } from 'components'
import { reverse } from 'named-urls'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'
import constants from 'constants/index'
import usePermissions from 'hooks/usePermissions'
import { history } from 'service'
import { routes } from 'Routes'

const RecentCampaignsTable = ({ campaigns, isLoading, count, pagination }) => {
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    pagination

  const permissions = usePermissions()
  const canViewCampaign = permissions.some([
    constants.permissions.PHISHING.LIST,
    constants.permissions.PHISHING.MANAGE,
  ])

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h4">Campanhas recentes</Typography>
      </Box>
      <Card>
        <PerfectScrollbar
          options={{ wheelPropagation: false, useBothWheelAxes: true }}
        >
          <Table
            emptyMessage="Nenhuma campanha encontrada."
            isLoading={isLoading}
            size="small"
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell width="30%">Nome da campanha</TableCell>
                <TableCell width="14%">Data Agendada</TableCell>
                <TableCell align="center" width="10%">
                  <Tooltip title="Total de e-mails entregues">
                    <span>Entregues</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" width="10%">
                  <Tooltip title="Total de cliques no link falso">
                    <span>Cliques</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" width="10%">
                  <Tooltip title="Total de participantes comprometidos">
                    <span>Comprometidos</span>
                  </Tooltip>
                </TableCell>
                <TableCell width="12%">Status</TableCell>
                {canViewCampaign && (
                  <TableCell align="right" width="8%">
                    Ações
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {campaigns?.map((campaign) => (
                <TableRow key={campaign?.id}>
                  <TableCell width="30%" applyNoWrap disableTooltip={false}>
                    {campaign?.name}
                  </TableCell>
                  <TableCell width="14%">
                    {campaign?.scheduleType ===
                    constants.phishing.DISPATCH_SCHEDULED
                      ? helpers.formatters.ptBrFormatDateTime(
                          campaign?.scheduledAt,
                        )
                      : constants.phishing.DISPATCH_OPTIONS.find(
                          (option) => option.value === campaign?.scheduleType,
                        )?.label || '-'}
                  </TableCell>
                  <TableCell align="center" width="10%">
                    {campaign?.phishingCampaignSummary?.delivered ?? '-'}
                  </TableCell>
                  <TableCell align="center" width="10%">
                    {campaign?.phishingCampaignSummary?.clicked ?? '-'}
                  </TableCell>
                  <TableCell align="center" width="10%">
                    {campaign?.phishingCampaignSummary?.compromised ?? '-'}
                  </TableCell>
                  <TableCell width="12%">
                    {constants.phishing.STATUS_LABEL[campaign?.status] || '-'}
                  </TableCell>
                  {canViewCampaign && (
                    <TableCell align="right" width="8%">
                      <MenuButton>
                        <Button
                          color="secondary"
                          fullWidth
                          size="small"
                          onClick={() =>
                            history.push(
                              reverse(routes.phishing.show, {
                                phishingId: campaign?.id,
                              }),
                            )
                          }
                        >
                          Visualizar
                        </Button>
                      </MenuButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
        <Box px={2}>
          <TablePagination
            component="div"
            count={count}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[3, 5, 10]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      </Card>
    </Box>
  )
}

RecentCampaignsTable.propTypes = {
  campaigns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  count: PropTypes.number,
  pagination: PropTypes.shape({
    perPage: PropTypes.number,
    page: PropTypes.number,
    handleChangePage: PropTypes.func,
    handleChangeRowsPerPage: PropTypes.func,
  }).isRequired,
}

export default RecentCampaignsTable
